<template>
  <b-card-code title="Log Kaji Etik">
    <app-timeline>
      <div v-for="item in log_pengajuan" :key="item.id">
        <app-timeline-item
          :title="item.title"
          :subtitle="item.status"
          :time="item.datetime"
          :variant="item.tipe"
        />
        <br>
      </div>
    </app-timeline>

    <!-- <template #code>
      {{ codeBasic }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
// import { codeBasic } from './code'

export default {
  components: {
    BCardCode,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    log_pengajuan: {},
  },
  data() {
    return {
      // codeBasic,
    }
  },
}
</script>
